import React from "react";
import blog from '../../Gif/BlogWrite.gif'
const Blogs = () => {
  return (
    <div className="container text-center">
    <h1 className="display-3 pt-5">
                Blogs are Cooking
            </h1>
            <img src={blog} className="img-fluid" alt=""/>
      <div className="row">
        <div className="col-md-5">
        

        </div>
        <div className="col-md-2"></div>
        <div className="col-md-5">
            
        </div>
      </div>
    </div>
  );
};

export default Blogs;
